import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';
import { GEO_SCOPE_OPTIONS } from '../../../utils/threats';

export const GeoScopeChooser = ({ onChange, selected = [] }) => {
  const { t } = useTranslation();
  const timeoutRef = useRef(null);

  const allOptions = useMemo(
    () => GEO_SCOPE_OPTIONS.map((v) => ({ value: v.value, label: t(v.label) })),
    [t],
  );

  const value = useMemo(
    () => allOptions.filter((o) => selected.includes(o.value)),
    [allOptions, selected],
  );

  const DEFAULT_GEO_SCOPE = [
    'United States of America',
    'Russia',
    'Germany',
    'Ukraine',
    'France',
    'United Kingdom',
    'India',
    'Nigeria',
    'Kazakhstan',
    'Indonesia',
  ];

  const defaultOptions = DEFAULT_GEO_SCOPE.map((v) => allOptions.find((o) => o.value === v)).filter(Boolean);

  const loadOptions = (inputValue, callback) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      const q = inputValue.trim().toLowerCase();
      callback(
        q ? allOptions.filter((o) => o.label.toLowerCase().includes(q)) : defaultOptions,
      );
    }, 300);
  };

  return (
    <div className='chooser country-search-filter'>
      <AsyncSelect
        className="select-filter"
        classNamePrefix="select-filter"
        isMulti
        defaultOptions={defaultOptions}
        loadOptions={loadOptions}
        value={value}
        onChange={(vals) => onChange((vals || []).map((o) => o.value))}
        placeholder={t('Please enter at least 1 symbol')}
        noOptionsMessage={() => t('No options')}
        loadingMessage={() => t('Loading...')}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
      />
    </div>
  );
};
